import { useState } from 'react';

const faqs = [
  {
    question: '火影同人游戏是什么？',
    answer: '火影同人游戏是基于《火影忍者》动漫世界观，由粉丝或独立开发者创作的非官方游戏作品。这些游戏涵盖角色扮演（RPG）、格斗对战、策略养成、冒险探索等多种类型，通常免费提供给玩家体验。火影同人游戏以创新的玩法和丰富的剧情深受火影粉丝喜爱。',
  },
  {
    question: '火影同人游戏需要付费吗？',
    answer: '大部分火影同人游戏都是免费畅玩的。这些火影同人免费游戏通常通过广告或自愿赞助来维持运营。部分火影同人手游可能提供内购选项用于购买皮肤或道具，但核心游戏内容都是免费提供的。我们网站推荐的都是经过验证的优质免费火影同人游戏。',
  },
  {
    question: '如何选择适合自己的火影同人游戏？',
    answer: '选择火影同人游戏时，可以先确定自己喜欢什么类型的玩法。如果你喜欢沉浸式剧情，可以选择火影同人角色扮演游戏；如果你喜欢快节奏对战，火影同人格斗游戏会更适合你；如果你喜欢策略思考，可以尝试火影忍者同人RPG类作品。我们也建议你根据设备选择——通勤路上适合玩火影同人手游，在家则可以选择画质更好的PC端火影同人游戏。',
  },
  {
    question: '火影同人游戏可以在手机上玩吗？',
    answer: '当然可以！目前市面上有大量的火影同人手游可供选择。这些火影同人手机游戏针对触屏操作进行了优化，让你随时随地都能体验忍者世界的乐趣。我们网站有专门的手机游戏分类，可以帮你快速找到适合的手机端火影同人游戏。',
  },
  {
    question: '火影同人格斗游戏有在线对战功能吗？',
    answer: '许多热门的火影同人格斗游戏都支持在线PVP对战。你可以与来自世界各地的玩家进行实时忍术对决，测试自己的操作技术和角色理解。部分火影同人格斗游戏还有排位系统，让你在竞技中不断提升自己的水平。',
  },
  {
    question: '如何下载火影同人游戏？',
    answer: '火影同人游戏下载方式因游戏而异。网页版火影同人游戏通常直接在浏览器中运行，无需下载。PC端游戏可以通过官方网站或游戏平台下载安装包。火影同人手游则可以通过应用商店搜索下载。我们会在每款游戏的详情页提供具体的下载指引。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            关于火影同人游戏的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-heading font-bold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}